module.exports = __webpack_public_path__ + "r-v3/img/ico_arrowLeft_white.bc9c3ac9.svg";